<div class="container">
  <article class="section-outset-y featured-collection">
    @if (block.image?.absoluteUrl) {
      <figure class="featured-collection__figure" [class.is--compact]="block.compact">
        <!-- <img
        class="product-image-ratio"
        [src]="block.image?.url || '' | resize: 1400:1925:'topleft':'crop':'webp'"
        [alt]="block.image?.caption || block.title"
        /> -->
        @if (block.image?.absoluteUrl) {
          <img
            class="product-image-ratio"
            [ngSrc]="block.image?.absoluteUrl!"
            [width]="600"
            [height]="800"
            ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            [attr.data-object-position]="block.image?.anchor || 'middlecenter'"
            [loaderParams]="{
              anchor: block.image?.anchor || 'middlecenter',
              mode: 'crop',
              format: 'webp',
              width: 600,
              height: 800,
            }"
            [alt]="block.image?.caption || block.title"
          />
        }
      </figure>
    }
    <main class="featured-collection__main">
      @if (block.subtitle) {
        <strong class="fw-semi">{{ block.subtitle }}</strong>
      }
      @if (block.title) {
        <h2 class="h1">{{ block.title }}</h2>
      }
      @if (block?.text || block?.intro) {
        <p class="featured-collection__main__text text-max-width-xs mx-auto fw-normal">
          {{ block.intro || block.text }}
        </p>
      }
      <div class="featured-collection__main__actions">
        @if (block.button?.routerLink?.length) {
          <a class="button button--secondary" [routerLink]="block.button?.routerLink">
            {{ block.button?.text || ('standaard-knoptekst' | fromDictionary) }}
          </a>
        }
        @if (!block.button?.routerLink?.length) {
          <a class="button button--secondary" [href]="block.button?.url">
            {{ block.button?.text || ('standaard-knoptekst' | fromDictionary) }}
          </a>
        }
        @if (block.secondaryButton) {
          @if (block.secondaryButton.routerLink?.length) {
            <a class="button button-outline button--theme-overlay" [routerLink]="block.secondaryButton.routerLink">
              {{ block.secondaryButton.text }}
            </a>
          }
          @if (!block.secondaryButton.routerLink?.length) {
            <a class="button button-outline button--theme-overlay" [href]="block.secondaryButton.url">
              {{ block.secondaryButton.text }}
            </a>
          }
        }
      </div>
    </main>
  </article>
</div>
